import React, { useState, useEffect, useRef } from 'react';

/**
 * Sticky help button that expands to show WhatsApp and Email contact options
 * Positioned at bottom-right of screen with slide-up animation
 */
const HelpButton = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const menuRef = useRef(null);

  // Animation styles
  const slideUpAnimation = {
    animation: 'slideUp 0.2s ease-out'
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsExpanded(false);
      }
    };

    if (isExpanded) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isExpanded]);

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/85251776613', '_blank', 'noopener,noreferrer');
    setIsExpanded(false);
  };

  const handleEmailClick = () => {
    window.location.href = 'mailto:aileen@mandarintutorhk.com';
    setIsExpanded(false);
  };

  return (
    <>
      {/* Keyframes for slide-up animation */}
      <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>

      <div className="fixed bottom-6 right-6 z-50" ref={menuRef}>
      {/* Expanded Menu */}
      {isExpanded && (
        <div 
          className="absolute bottom-20 right-0 w-40 bg-gray-800 border border-gray-700 rounded-lg shadow-xl overflow-hidden"
          style={slideUpAnimation}
        >
          {/* Close Button */}
          <button
            onClick={() => setIsExpanded(false)}
            className="w-full px-4 py-3 text-gray-400 hover:bg-gray-700 transition-colors text-center text-sm font-medium border-b border-gray-700"
          >
            ✕ Close
          </button>

          {/* WhatsApp Button */}
          <button
            onClick={handleWhatsAppClick}
            className="w-full px-4 py-4 text-green-500 hover:text-green-400 hover:bg-gray-700 transition-colors flex flex-col items-center gap-1 border-b border-gray-700"
          >
            <svg 
              className="w-6 h-6" 
              fill="currentColor" 
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
            </svg>
            <span className="text-sm font-medium">WhatsApp Us</span>
          </button>

          {/* Email Button */}
          <button
            onClick={handleEmailClick}
            className="w-full px-4 py-4 text-purple-400 hover:text-purple-300 hover:bg-gray-700 transition-colors flex flex-col items-center gap-1"
          >
            <svg 
              className="w-6 h-6" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" 
              />
            </svg>
            <span className="text-sm font-medium">Email Us</span>
          </button>
        </div>
      )}

      {/* Main Help Button */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-16 h-16 bg-purple-600 hover:bg-purple-700 rounded-full shadow-lg flex flex-col items-center justify-center text-white font-medium transition-all duration-200"
        aria-label="Help"
      >
        <span className="text-2xl">?</span>
        <span className="text-xs">Help</span>
      </button>
    </div>
    </>
  );
};

export default HelpButton;